import {createRouter, createWebHistory} from "vue-router";
import LinkDisplayView from "@/views/LinkDisplayView.vue";
import {useAuthStore} from "@/stores/auth.store";

export enum PagesEnum {
    HOME = "home",
    SIGN_IN = "sign-in",
    DASHBOARD = "dashboard",
    EDIT_LINK = "edit-link",
    CREATE_LINK = "create-link",
    LINK_DISPLAY = "link-display",
}

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            redirect: { name: PagesEnum.DASHBOARD }
        },
        {
            path: "/l/:guid",
            props: true,
            name: PagesEnum.LINK_DISPLAY,
            component: LinkDisplayView,
        },
        {
            path: "/sign-in",
            name: PagesEnum.SIGN_IN,
            component: () => import("../views/SignIn.vue"),
            beforeEnter: (to, from, next) => {
                const isLoggedIn = useAuthStore().isLoggedIn;
                if (isLoggedIn) next({name: PagesEnum.DASHBOARD});
                else next();
            },
        },
        {
            path: "/dashboard",
            name: PagesEnum.DASHBOARD,
            component: () => import("../views/LinkDashboardView.vue"),
        },
        {
            path: "/link/",
            name: PagesEnum.CREATE_LINK,
            props: true,
            component: () => import("../views/EditLinkView.vue")
        },
        {
            path: "/link/:id?",
            name: PagesEnum.EDIT_LINK,
            props: true,
            component: () => import("../views/EditLinkView.vue")
        }
    ],
});

const notAuthenticatedPages = [PagesEnum.LINK_DISPLAY, PagesEnum.SIGN_IN];
router.beforeEach((to, from, next) => {
    const isLoggedIn = useAuthStore().getUser;
    const isAuthenticatedPage = !notAuthenticatedPages.includes(
        to.name as PagesEnum
    );
    const isNotAllowed = isAuthenticatedPage && !isLoggedIn;

    if (isNotAllowed) next({name: PagesEnum.SIGN_IN});
    else next();
});
export default router;
